module.exports = __webpack_public_path__ + "static/media/logo.71bcdda3.svg";